import { createTagTokens } from '../tokens/components.js';
import { type SemanticTokens, SEMANTIC } from '../tokens/semantic.js';

/**
 * Tag Component Configuration
 */
export function createTag(s: SemanticTokens) {
  const tagTokens = createTagTokens(s);
  return {
  root: {
    fontSize: tagTokens.base.fontSize,
    fontWeight: tagTokens.base.fontWeight,
    padding: tagTokens.base.paddingY,
    gap: tagTokens.base.gap,
    borderRadius: tagTokens.base.radius,
    roundedBorderRadius: tagTokens.base.radius,
  },
  icon: { size: tagTokens.base.iconSize },
  primary: {
    background: tagTokens.brand.bg,
    color: tagTokens.brand.fg,
  },
  secondary: {
    background: tagTokens.secondary.bg,
    color: tagTokens.secondary.fg,
  },
  success: {
    background: tagTokens.status.success.bg,
    color: tagTokens.status.success.fg,
  },
  info: {
    background: tagTokens.status.neutralInfo.bg,
    color: tagTokens.status.neutralInfo.fg,
  },
  warn: {
    background: tagTokens.status.warning.bg,
    color: tagTokens.status.warning.fg,
  },
  danger: {
    background: tagTokens.status.danger.bg,
    color: tagTokens.status.danger.fg,
  },
  colorScheme: {
    light: {
      primary: { background: tagTokens.brand.bg, color: tagTokens.brand.fg },
      secondary: { background: tagTokens.secondary.bg, color: tagTokens.secondary.fg },
      success: { background: tagTokens.status.success.bg, color: tagTokens.status.success.fg },
      info: { background: tagTokens.status.neutralInfo.bg, color: tagTokens.status.neutralInfo.fg },
      warn: { background: tagTokens.status.warning.bg, color: tagTokens.status.warning.fg },
      danger: { background: tagTokens.status.danger.bg, color: tagTokens.status.danger.fg },
    },
  },
  css: () => `
    .p-tag {
      font-family: ${tagTokens.base.fontFamily};
      white-space: nowrap;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      white-space: wrap;
      text-align: center;
      height: ${tagTokens.base.height}; /* 24px */
    }
    
    .p-tag-label {
      line-height: ${tagTokens.base.lineHeight};
    }
    
    .p-tag-icon {
      width: ${tagTokens.base.iconSize};
      height: ${tagTokens.base.iconSize};
      font-size: ${tagTokens.base.iconSize};
    }
    
    /* Emphasis variant - larger text (16px vs 12px), icon stays 16px */
    p-tag[pTagEmphasis] .p-tag {
      font-size: ${tagTokens.emphasis.fontSize};
    }
    
    p-tag[pTagEmphasis] .p-tag-label {
      font-size: ${tagTokens.emphasis.fontSize};
      line-height: ${tagTokens.emphasis.lineHeight};
      font-weight: ${tagTokens.emphasis.fontWeight};
    }
  `,
  };
}
export const tag = createTag(SEMANTIC);